import type { RecalculateFieldsParams } from './shared/logic';
import { recalculateFieldsNC } from './templates/NC/ncLogic';
import { recalculateFieldsDirect } from './templates/MASDirect/masDirectLogic';
import { recalculateFieldsIndirect } from './templates/MASIndirect/masIndirectLogic';
import { FIELD_DEPENDENCIES_NC } from './templates/NC/ncLogic';
import { FIELD_DEPENDENCIES_DIRECT } from './templates/MASDirect/masDirectLogic';
import { FIELD_DEPENDENCIES_INDIRECT } from './templates/MASIndirect/masIndirectLogic';

/** Merged field dependencies from all templates (for consumers that need a single map). */
export const FIELD_DEPENDENCIES: Record<string, string[]> = {
  ...FIELD_DEPENDENCIES_NC,
  ...FIELD_DEPENDENCIES_DIRECT,
  ...FIELD_DEPENDENCIES_INDIRECT,
};

/**
 * Single entry for recalc: delegates to template-specific recalculateFields by templateType/productType.
 */
export function recalculateFields(params: RecalculateFieldsParams): Record<string, any> {
  if (params.templateType === 'nc') return recalculateFieldsNC(params);
  if (params.productType === 'direct') return recalculateFieldsDirect(params);
  return recalculateFieldsIndirect(params);
}


/** Re-export shared logic so existing imports from this file keep working. */
export * from './shared/logic';
